import { Component } from '@angular/core';

import { ModalComponent } from '../modal/modal.component';
import { BaseMenuComponent } from './base.menu';
import { OfflineService } from '../shared/services/offline-mode.service';
import { Person, Inspection } from '../shared/models';
import { InspectionClipboardService } from '../shared/services/inspection-clipboard.service';
import { InspectionService } from '../shared/services';
import { Observable } from 'rxjs';
@Component({
    templateUrl: './inspection.menu.html',
    standalone: false
})
export class InspectionMenuComponent extends BaseMenuComponent {
  public menus: any = InspectionDetailMenu;
  inspection: Inspection;
  currentPerson: Person;

  public anyModules = false;
  checkSapPrices$: Observable<{ available: boolean }>;

  constructor(
    public modal: ModalComponent,
    private offline: OfflineService,
    private clipboard: InspectionClipboardService,
    private inspectionService: InspectionService
  ) {
    super(modal);
    this.selectedGroup = 'general';
  }

  init(data: any) {
    this.inspection = data.inspection;
    this.currentPerson = data.currentPerson;
    this.anyModules = data.anyModules;
    this.checkSapPrices$ = this.inspectionService.checkSapPrices(this.inspection.id);
  }

  canSendToValidate() {
    return this.inspection.progression === 100;
  }

  public get isOptimization() {
    return this.inspection.applicationType === 1;
  }

  public get isMaintenance() {
    return this.inspection.applicationType === 0;
  }

  public get isInstallation() {
    return this.inspection.applicationType === 2;
  }

  public get hasActionPlan() {
    return !!this.inspection.actionPlanId;
  }

  public get isInOffline() {
    return this.inspection.isOffline;
  }

  public get someInspectionOffline() {
    return this.offline.someInspectionOffline;
  }

  public get onlyOnline() {
    return this.isConnection && !this.isInOffline;
  }

  public get isManager() {
    return this.offline.isManager;
  }

  public isPaste(): boolean {
    return this.clipboard.hasData(this.inspection);
  }
}

export enum InspectionDetailMenu {
  Information = 1,
  Properties = 2,
  ImportModule = 3,
  AddPlugin = 4,
  CreateModule = 5,
  ImportParts = 6,
  Delete = 7,
  OrderModules = 8,
  SendToValidate = 9,
  Status = 10,
  OrderPlugins = 11,
  ReportList = 12,
  ExportParts = 13,
  DownloadReport = 14,
  Collaborate = 15,
  ChangeInputLanguage = 16,
  OpenActionPlan = 17,
  AvailableOffline = 18,
  RemoveFromOffline = 19,
  Synchronize = 20,
  TrashCan = 21,
  EditJson = 22,
  CopySelectedModules = 23,
  CutSelectedModules = 24,
  PastModules = 25,
  DeleteSelectedModules = 26,
  ImportPartPrices = 27,
  OpenMachines = 28,
  ManageParts = 29,
  AssociateMachines = 30,
  DownloadTranslation = 31,
  ImportTranslation = 32
}
